<template>
    <div class="users-container reportEnrolsWeeduc">
        <div class="weeduc-admin-reports-kpi" :aria-label="$t('admin.reports.salesSummaryAria')">
            <article class="weeduc-admin-reports-kpi__card">
                <h4 class="weeduc-admin-reports-kpi__label">{{ $t('admin.reports.kpi.totalSales') }}</h4>
                <p class="weeduc-admin-reports-kpi__value">{{ numberSales }}</p>
            </article>
            <article class="weeduc-admin-reports-kpi__card">
                <h4 class="weeduc-admin-reports-kpi__label">
                    {{ isMobile ? $t('admin.reports.kpi.monthSalesShort') : $t('admin.reports.kpi.monthTotal') }}
                </h4>
                <p class="weeduc-admin-reports-kpi__value">{{ formatCurrency(salesMonth) }}</p>
            </article>
            <article class="weeduc-admin-reports-kpi__card">
                <h4 class="weeduc-admin-reports-kpi__label">
                    {{ isMobile ? $t('admin.reports.kpi.semesterShort') : $t('admin.reports.kpi.semesterTotal') }}
                </h4>
                <p class="weeduc-admin-reports-kpi__value">{{ formatCurrency(salesSemester) }}</p>
            </article>
            <article class="weeduc-admin-reports-kpi__card">
                <h4 class="weeduc-admin-reports-kpi__label">
                    {{ isMobile ? $t('admin.reports.kpi.yearShort') : $t('admin.reports.kpi.yearTotal') }}
                </h4>
                <p class="weeduc-admin-reports-kpi__value">{{ formatCurrency(salesYear) }}</p>
            </article>
        </div>

        <AdvancedFilters
            ref="advancedFilters"
            class="weeduc-admin-reports-filters--stacked"
            :show-date-filter="true"
            :show-course-filter="true"
            :show-user-filter="true"
            @filters-applied="onFiltersApplied"
            @filters-cleared="onFiltersCleared"
        />

        <Loader v-if="!hasReady" />
        <div v-else class="weeduc-admin-reports__table-block">
            <v-table class="custom-table table-with-filters">
                <thead>
                    <tr>
                        <th style="width: 18%; text-align: left;" class="sortable-header" @click="sortBy('userName')">
                            {{ $t('admin.reports.columns.clientName') }}
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 18%; text-align: left;" class="sortable-header" @click="sortBy('courseName')">
                            {{ $t('admin.reports.columns.courseName') }}
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 12%; text-align: left;" class="sortable-header" @click="sortBy('status')">
                            {{ $t('admin.reports.columns.status') }}
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 15%; text-align: left;" class="sortable-header" @click="sortBy('date')">
                            {{ $t('admin.reports.columns.createdAt') }}
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 15%; text-align: left;" class="sortable-header" @click="sortBy('total')">
                            {{ $t('admin.reports.columns.total') }}
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 8%; text-align: left;" class="sortable-header" @click="sortBy('typePayment')">
                            {{ $t('admin.reports.columns.paymentType') }}
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 8%; text-align: left;" class="sortable-header" @click="sortBy('discount')">
                            {{ $t('admin.reports.columns.discount') }}
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="order in paginatedCourses" :key="order.id">
                        <td style="width: 18%; text-align: left;">{{ order.userName || 'N/A' }}</td>
                        <td style="width: 18%; text-align: left;">{{ order.courseName || 'N/A' }}</td>
                        <td style="width: 12%; text-align: left;">
                            <v-chip
                                density="compact"
                                :color="order.status == 1 ? 'success' : 'warning'"
                            >
                                {{ order.status == 1 ? $t('admin.reports.status.approved') : $t('admin.reports.status.pending') }}
                            </v-chip>
                        </td>
                        <td style="width: 15%; text-align: left;">{{ formatarData(order.dateInsert) }}</td>
                        <td style="width: 15%; text-align: left;">
                            {{ formatCurrency(order.total) }}
                        </td>
                        <td style="width: 10%; text-align: left;">{{ getPaymentType(order.typePayment) }}</td>
                        <td style="width: 10%; text-align: left;">
                            {{ formatCurrency(order.discount) }}
                        </td>
                    </tr>
                </tbody>
            </v-table>
        </div>

        <div class="pagination users-pagination">
            <v-responsive>
                <v-pagination
                    :model-value="currentPage + 1"
                    :length="totalPages"
                    :total-visible="5"
                    :disabled="!hasReady"
                    @update:model-value="onPageChange"
                ></v-pagination>
                <div v-if="totalElements > 0" class="pagination-info">
                    {{ $t('admin.reports.showingRange', { from: (currentPage * pageSize) + 1, to: Math.min((currentPage + 1) * pageSize, totalElements), total: totalElements }) }}
                </div>
            </v-responsive>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader/loader.vue';
import AdvancedFilters from '@/components/Admin/Reports/AdvancedFilters.vue';
import api from '@/utils/reports.js';
import { mapState } from 'vuex';
import { toast } from 'vue3-toastify';


    export default {
        data() {
            return {
                label: this.labels,
                userFiltered: [],
                searchTerm: '',
                status: 'all',
                currentPage: 0,
                pageSize: 10,
                totalPages: 0,
                totalElements: 0,
                alertOpenCourse: false,
                removedcoursename: '',
                afterWidth: 40,
                usersInfo: [],
                openModalCreateWarning: false,
                openModalEditWarning: false,
                hasReady: false,
                indiceItem: [false, false, false, true],
                isMobileIcon: false,
                isMobile: false,
                numberSales: 0,
                salesMonth: 0,
                salesSemester: 0,
                salesYear: 0,
                currentSort: { field: '', order: 'asc' },
                activeFilters: {}, // Armazenar filtros ativos para export
            };
        },
        props: {
            labels: Array,
            searchTerm: String,
        },
        computed: {
            ...mapState(['token', 'numberIntensTable']),
            paginatedCourses() {
                // Retornar todos os dados da página atual (já vem paginado da API)
                return this.userFiltered || [];
            },
        },
        watch: {
            searchTerm(newTerm) {
                this.filteredUsers(newTerm);
            },
        },
        methods: {
            checkIfMobile() {
                this.isMobile = window.matchMedia('(max-width: 600px)').matches;
            },
            async exportToCSV() {
                try {
                    toast.info(this.$t('admin.reports.exporting'));
                    
                    // Preparar filtros para a API de export
                    const exportFilters = {};
                    
                    if (this.activeFilters.status) {
                        exportFilters.status = this.activeFilters.status;
                    }
                    if (this.activeFilters.name) {
                        exportFilters.name = this.activeFilters.name;
                    }
                    if (this.activeFilters.userName) {
                        exportFilters.name = this.activeFilters.userName;
                    }
                    if (this.activeFilters.courseName) {
                        exportFilters.courseName = this.activeFilters.courseName;
                    }
                    if (this.activeFilters.startDate) {
                        exportFilters.startDate = this.activeFilters.startDate;
                    }
                    if (this.activeFilters.endDate) {
                        exportFilters.endDate = this.activeFilters.endDate;
                    }
                    
                    // Chamar endpoint de export
                    const response = await api.getDataOrderExport(this.token, exportFilters);
                    
                    // Fazer download do arquivo blob
                    const url = window.URL.createObjectURL(response);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'relatorio_vendas.csv');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    toast.success(this.$t('admin.reports.exportSuccess'));
                } catch (error) {
                    toast.error(this.$t('admin.reports.exportError'));
                    console.error('Erro ao exportar CSV:', error);
                }
            },
            filteredUsers(searchTerm) {
                if (searchTerm.trim() === '') {
                    this.userFiltered = this.usersInfo;
                } else {
                    this.userFiltered = this.usersInfo.filter((order) =>
                        (order.userName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
                        (order.courseName || '').toLowerCase().includes(searchTerm.toLowerCase())
                    );
                }
                this.currentPage = 0;
            },
            async getDataReport(searchTerm = '') {
                try {
                    this.hasReady = false;
                    
                    const filters = {};
                    
                    if (searchTerm && searchTerm.trim() !== '') {
                        // Se houver searchTerm, buscar por nome do cliente
                        filters.name = searchTerm.trim();
                    }
                    
                    const pagination = {
                        page: this.currentPage,
                        size: this.pageSize
                    };
                    
                    console.log('enrols.vue - buscando dados com filtros:', filters, 'pagination:', pagination);
                    
                    const response = await api.getDataOrder(this.token, filters, pagination);
                    console.log('enrols.vue - resposta da API:', response);
                    
                    // Processar resposta (mesmo que vazia)
                    this.usersInfo = response?.content || [];
                    this.userFiltered = response?.content || [];
                    this.numberSales = response?.totalElements || 0;
                    this.totalPages = response?.totalPages || 0;
                    this.totalElements = response?.totalElements || 0;
                    
                    // Atualizar estatísticas
                    if (this.userFiltered.length > 0) {
                        this.calculateStatistics(this.userFiltered);
                    } else {
                        // Se não houver dados, manter as estatísticas do resumo geral
                        await this.fetchOrderSummary();
                    }
                    
                    this.hasReady = true;
                    
                    // Mostrar mensagem se não houver resultados
                    if (this.userFiltered.length === 0 && searchTerm) {
                        toast.info(this.$t('admin.reports.noSearchResults'));
                    }

                } catch (error) {
                    toast.error(this.$t('admin.reports.loadError'));
                    console.error('Erro Report Vendas', error);
                    // Garantir que mesmo em caso de erro, os dados sejam limpos
                    this.usersInfo = [];
                    this.userFiltered = [];
                    this.numberSales = 0;
                    this.totalPages = 0;
                    this.totalElements = 0;
                    this.hasReady = true;
                }
            },
            async onPageChange(page) {
                // Converter de 1-based (UI) para 0-based (API)
                this.currentPage = page - 1;
                await this.getDataReport();
            },
            formatPrice(value) {
                return value.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            },
            formatCurrency(value) {
                if (value === null || value === undefined || value === '') {
                    return 'R$ 0,00';
                }
                
                // Converter para número se for string
                const numValue = typeof value === 'string' ? parseFloat(value) : value;
                
                // Verificar se é um número válido
                if (isNaN(numValue)) {
                    return 'R$ 0,00';
                }
                
                // Formatar como moeda brasileira
                return numValue.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            },
            getPaymentType(typePayment) {
                const paymentTypes = {
                    1: this.$t('admin.reports.payment.card'),
                    3: this.$t('admin.reports.payment.boleto'),
                    9: this.$t('admin.reports.payment.pix')
                };
                return paymentTypes[typePayment] || this.$t('admin.reports.payment.typeFallback', { type: typePayment || 'N/A' });
            },
            filteredUsers() {
                if (this.searchTerm.trim() === '') {
                    this.userFiltered = this.usersInfo;
                } else {
                    this.userFiltered = this.usersInfo.filter((user) =>
                        user.userName
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())
                    );
                }
                return this.userFiltered;
            },
            formatarData(date) {
                return new Date(date).toLocaleDateString();
            },
            async fetchOrderSummary() {
                try {
                    const summary = await api.getDataOrderSummary(this.token);
                    this.numberSales = summary.totalSalesCount || 0;
                    // Garantir que os valores sejam números
                    this.salesMonth = parseFloat(summary.monthlySalesTotal) || 0;
                    this.salesSemester = parseFloat(summary.semiAnnualSalesTotal) || 0;
                    this.salesYear = parseFloat(summary.annualSalesTotal) || 0;
                } catch (error) {
                    toast.error(this.$t('admin.reports.salesSummaryError'));
                    console.error('Erro ao buscar resumo de vendas:', error);
                }
            },
            onFiltersApplied(filters) {
                this.applyAdvancedFilters(filters);
            },
            onFiltersCleared() {
                this.clearAdvancedFilters();
            },
            async applyAdvancedFilters(filters) {
                try {
                    this.hasReady = false;
                    
                    // Armazenar filtros ativos para export
                    this.activeFilters = { ...filters };
                    if (filters.dateFrom) this.activeFilters.startDate = filters.dateFrom;
                    if (filters.dateTo) this.activeFilters.endDate = filters.dateTo;
                    
                    // Preparar filtros para a API
                    const apiFilters = {};
                    
                    // Filtro por nome do curso
                    if (filters.courseName && filters.courseName.trim() !== '') {
                        apiFilters.courseName = filters.courseName.trim();
                    }
                    
                    // Filtro por nome do usuário/cliente
                    if (filters.userName && filters.userName.trim() !== '') {
                        apiFilters.name = filters.userName.trim();
                    }
                    
                    // Filtro por data
                    if (filters.dateFrom) {
                        apiFilters.startDate = filters.dateFrom;
                    }
                    if (filters.dateTo) {
                        apiFilters.endDate = filters.dateTo;
                    }
                    
                    // Resetar para primeira página ao aplicar filtros
                    this.currentPage = 0;
                    
                    const pagination = {
                        page: this.currentPage,
                        size: this.pageSize
                    };
                    
                    // Buscar dados da API com os filtros
                    console.log('Aplicando filtros via API:', apiFilters, 'pagination:', pagination);
                    const response = await api.getDataEnrols(this.token, apiFilters, pagination);
                    
                    // Processar resposta da API (mesmo que vazia)
                    let filteredData = response?.content || [];
                    this.usersInfo = filteredData; // Atualizar dados base
                    this.totalPages = response?.totalPages || 0;
                    this.totalElements = response?.totalElements || 0;
                    
                    // Aplicar filtros de valores localmente (se necessário)
                    if (filters.totalFilter) {
                        filteredData = this.filterByValue(filteredData, 'total', filters.totalFilter);
                    }
                    
                    // Ordenação local
                    if (filters.sortBy) {
                        filteredData = this.sortData(filteredData, filters.sortBy, filters.sortOrder);
                    }
                    
                    this.userFiltered = filteredData;
                    this.numberSales = this.totalElements;
                    
                    // Atualizar estatísticas se houver dados
                    if (filteredData.length > 0) {
                        this.calculateStatistics(filteredData);
                    } else {
                        // Resetar estatísticas se não houver dados
                        this.salesMonth = 0;
                        this.salesSemester = 0;
                        this.salesYear = 0;
                    }
                    
                    this.hasReady = true;
                    
                    // Mostrar mensagem se não houver resultados
                    if (filteredData.length === 0) {
                        toast.info(this.$t('admin.reports.noFilterResults'));
                    }
                    
                } catch (error) {
                    toast.error(this.$t('admin.reports.filtersApplyError'));
                    console.error('Erro ao aplicar filtros:', error);
                    // Garantir que mesmo em caso de erro, os dados sejam limpos
                    this.userFiltered = [];
                    this.usersInfo = [];
                    this.numberSales = 0;
                    this.salesMonth = 0;
                    this.salesSemester = 0;
                    this.salesYear = 0;
                    this.hasReady = true;
                }
            },
            filterByValue(data, field, filter) {
                return data.filter(item => {
                    const value = parseFloat(item[field]) || 0;
                    const filterValue = filter.value;
                    const filterValueTo = filter.valueTo;
                    
                    switch (filter.operator) {
                        case 'greater':
                            return value > filterValue;
                        case 'less':
                            return value < filterValue;
                        case 'equal':
                            return value === filterValue;
                        case 'between':
                            return filterValueTo ? value >= filterValue && value <= filterValueTo : value >= filterValue;
                        default:
                            return true;
                    }
                });
            },
            sortData(data, sortBy, sortOrder) {
                return data.sort((a, b) => {
                    let aValue, bValue;
                    
                    switch (sortBy) {
                        case 'date':
                            aValue = new Date(a.dateInsert);
                            bValue = new Date(b.dateInsert);
                            break;
                        case 'total':
                            aValue = parseFloat(a.total) || 0;
                            bValue = parseFloat(b.total) || 0;
                            break;
                        case 'status':
                            aValue = a.status || 0;
                            bValue = b.status || 0;
                            break;
                        case 'typePayment':
                            aValue = a.typePayment || 0;
                            bValue = b.typePayment || 0;
                            break;
                        case 'userName':
                            aValue = (a.userName || '').toLowerCase();
                            bValue = (b.userName || '').toLowerCase();
                            break;
                        case 'courseName':
                            aValue = (a.courseName || '').toLowerCase();
                            bValue = (b.courseName || '').toLowerCase();
                            break;
                        case 'discount':
                            aValue = parseFloat(a.discount) || 0;
                            bValue = parseFloat(b.discount) || 0;
                            break;
                        default:
                            return 0;
                    }
                    
                    if (sortOrder === 'asc') {
                        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
                    } else {
                        return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
                    }
                });
            },
            async clearAdvancedFilters() {
                try {
                    this.hasReady = false;
                    this.currentPage = 0;
                    
                    const pagination = {
                        page: this.currentPage,
                        size: this.pageSize
                    };
                    
                    // Buscar todos os dados novamente sem filtros
                    const response = await api.getDataEnrols(this.token, {}, pagination);
                    this.usersInfo = response?.content || [];
                    this.userFiltered = response?.content || [];
                    this.numberSales = response?.totalElements || 0;
                    this.totalPages = response?.totalPages || 0;
                    this.totalElements = response?.totalElements || 0;
                    
                    // Atualizar estatísticas
                    if (this.userFiltered.length > 0) {
                        this.calculateStatistics(this.userFiltered);
                    }
                    
                    this.hasReady = true;
                } catch (error) {
                    console.error('Erro ao limpar filtros:', error);
                    this.userFiltered = [];
                    this.usersInfo = [];
                    this.totalPages = 0;
                    this.totalElements = 0;
                    this.hasReady = true;
                }
            },
            calculateStatistics(data) {
                // Calcular estatísticas com base nos dados fornecidos
                if (!data || data.length === 0) {
                    this.salesMonth = 0;
                    this.salesSemester = 0;
                    this.salesYear = 0;
                    return;
                }
                
                const now = new Date();
                const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                const startOfSemester = new Date(now.getFullYear(), now.getMonth() - 5, 1);
                const startOfYear = new Date(now.getFullYear(), 0, 1);
                
                let monthTotal = 0;
                let semesterTotal = 0;
                let yearTotal = 0;
                
                data.forEach(item => {
                    // Usar dateInsert se dateApproved não estiver disponível
                    const itemDate = item.dateApproved ? new Date(item.dateApproved) : new Date(item.dateInsert);
                    const total = parseFloat(item.total) || 0;
                    
                    if (itemDate >= startOfYear) {
                        yearTotal += total;
                    }
                    if (itemDate >= startOfSemester) {
                        semesterTotal += total;
                    }
                    if (itemDate >= startOfMonth) {
                        monthTotal += total;
                    }
                });
                
                // Armazenar como número para permitir formatação
                this.salesMonth = monthTotal;
                this.salesSemester = semesterTotal;
                this.salesYear = yearTotal;
            },
            sortBy(field) {
                if (this.currentSort.field === field) {
                    this.currentSort.order = this.currentSort.order === 'asc' ? 'desc' : 'asc';
                } else {
                    this.currentSort.field = field;
                    this.currentSort.order = 'asc';
                }
                
                this.userFiltered = this.sortData([...this.userFiltered], field, this.currentSort.order);
            },
        },
        components: {
            Loader,
            AdvancedFilters,
        },
        created() {
            this.getDataReport();
            this.checkIfMobile();
            this.fetchOrderSummary();
            window.addEventListener('resize', this.checkIfMobile);
        },
    };
</script>

<style scoped>
    /* Filtros colados à tabela (mesmo cartão visual) */
    .reportEnrolsWeeduc :deep(.weeduc-admin-reports-filters--stacked.weeduc-admin-page__toolbar) {
        border-radius: 12px 12px 0 0;
        margin-bottom: 0;
        border-bottom: none;
    }

    .weeduc-admin-reports__table-block {
        margin-top: 0;
    }

    .container {
        max-width: 100%;
        border-radius: 12px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    }
    .search-form-input {
        position: relative;
        width: 100%;
    }
    .title-container {
        position: relative;
        margin-bottom: 12px;
        padding-bottom: 0;
        border-bottom: 1px solid #f0f0f0;
        text-align: left;
    }

    .title-container .title {
        font-size: 1.5rem;
        font-weight: 700;
        color: #000000;
        margin-bottom: 0.5rem;
    }

    .title-container .subtitle {
        color: #6b7280;
        font-size: 0.875rem;
        line-height: 1.4;
        margin-bottom: 1rem;
    }

    .search-row {
        display: flex;
        gap: 0.75rem;
        margin-bottom: 1.5rem;
    }

    .search-row .form-group {
        flex: 1;
    }

    .export-button-container {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 1rem;
        margin-top: 1rem;
    }

    .export-button-container .btn-weflix {
        background-color: #2f2e8b;
        color: white;
        padding: 0.75rem 1.5rem;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-weight: 600;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(47, 46, 139, 0.2);
        border: none;
    }

    .export-button-container .btn-weflix:hover:not(:disabled) {
        background-color: #23225f;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(47, 46, 139, 0.3);
    }

    .export-button-container .btn-weflix:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    .export-button-container .btn-weflix svg {
        font-size: 1rem;
    }

    .btn-weflix.absolute {
        position: absolute;
        top: 0;
        right: 0;
        background-color: #2f2e8b;
        color: white;
        padding: 0.5rem 1rem;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-weight: 600;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(47, 46, 139, 0.2);
    }

    .btn-weflix.absolute:hover {
        background-color: #23225f;
        transform: translateY(-2px);
    }

    .users-table-responsive {
        background-color: #ffffff;
        border-radius: 8px;
        margin-bottom: 1rem;
    }

    .users-table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0;
    }

    .users-table th {
        background-color: #f8fafc;
        padding: 0.75rem;
        font-weight: 600;
        color: #4a5568;
        text-align: left;
        border-bottom: 2px solid #e2e8f0;
    }

    .users-table td {
        padding: 0.75rem;
        vertical-align: middle;
        border-bottom: 1px solid #f0f0f0;
        color: #4a5568;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
    }

    .users-table tr:hover {
        background-color: #f8fafc;
    }

    .badge-active,
    .badge-inactive {
        padding: 0.25rem 0.75rem;
        border-radius: 5px;
        font-size: 0.75rem;
        font-weight: 500;
        display: inline-block;
        text-align: center;
        transition: all 0.2s ease;
        width: 70%;
    }

    .badge-active {
        background-color: #7bcc8180;
        color: #4b614e;
    }

    .badge-inactive {
        background-color: #d7d7ee80;
        color: #2f2e8b;
    }

    .user-btn-edit {
        padding: 0.4rem;
        margin: 0 0.25rem;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.2s ease;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        color: #2f2e8b;
    }

    .search-form-input {
        position: relative;
    }

    .search-form-control {
        width: 100%;
        padding: 0.5rem 0.75rem;
        border: 1px solid #e2e8f0;
        border-radius: 6px;
        font-size: 0.875rem;
        transition: all 0.2s ease;
    }

    .search-form-control:focus {
        outline: none;
        border-color: #2f2e8b;
        box-shadow: 0 0 0 3px rgba(47, 46, 139, 0.1);
    }

    .search-input-icon {
        position: absolute;
        right: 0.75rem;
        top: 45%;
        transform: translateY(-50%);
        color: #9ca3af;
        cursor: pointer;
    }

    .pagination-info {
        text-align: center;
        margin-top: 0.65rem;
        font-size: 0.8125rem;
        color: #6b7280;
    }

    .users-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        margin-top: 1.15rem;
        padding-bottom: 0.25rem;
    }

    .users-page-btn {
        padding: 0.5rem 1rem;
        border: 1px solid #e2e8f0;
        border-radius: 6px;
        background: white;
        color: #4a5568;
        cursor: pointer;
        transition: all 0.2s;
    }

    .users-page-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .users-page-btn:not(:disabled):hover {
        background: #f8fafc;
        border-color: #cbd5e0;
    }

    .users-page-info {
        color: #4a5568;
        font-size: 0.875rem;
    }

    @media (max-width: 768px) {
        .container {
            padding: 1rem;
        }

        .search-row {
            flex-direction: column;
        }

        .users-table th,
        .users-table td {
            padding: 0.5rem;
        }
    }

    @media (max-width: 600px) {
        .btn-weflix.absolute {
            padding: 0.5rem;
        }

        .btn-weflix.absolute span {
            display: none;
        }

        .users-table-responsive {
            overflow-x: auto;
        }

    }

    select.form-control.filter-form-control {
        width: 60%;
    }
    .form-group.filter-form-group {
        justify-content: space-around;
        align-items: center;
        margin: 0 !important;
    }
    .form-group.search-form-group {
        margin: 0 !important;
    }
    table.table.users-table {
        border: none !important;
        padding: 0 !important;
    }
    button.btn-edit.user-btn-edit svg {
        color: #2f2e8b;
    }
    .form-group.filter-form-group {
        display: flex;
    }
    .btn-weflix.absolute span.flex {
        font-size: 16px;
    }
    .btn-weflix.absolute svg {
        color: white;
        font-size: 15px;
    }
    /* DARK */
    .dashboard.dark .reportEnrolsWeeduc .pagination-info {
        color: #9ca3b4;
    }
    .dashboard.dark .weeducAdminReports .users-table-responsive {
        background-color: #000;
    }
    .dashboard.dark .users-table-responsive {
        background-color: #000 !important;
    }
    .dashboard.dark .weeducAdminReports .users-table th {
        border-bottom: 2px solid #575757 !important;
    }
.dashboard.dark .weeducAdminReports .users-table td {
    border-bottom: 2px solid #575757 !important;
}

.sortable-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s ease;
    position: relative;
}

.sortable-header:hover {
    background-color: #f1f3f4;
}

.sort-icon {
    margin-left: 0.5rem;
    opacity: 0.5;
    transition: opacity 0.2s ease;
}

.sortable-header:hover .sort-icon {
    opacity: 1;
}

.dashboard.dark .sortable-header:hover {
    background-color: #666;
}

.table-with-filters {
    border-radius: 0 0 12px 12px;
    border: 1px solid #e8eaf0;
    border-top: 1px solid #eef0f4;
    overflow: hidden;
}

.dashboard.dark .table-with-filters {
    border-color: #3d414d;
    border-top-color: #353945;
}

.dashboard.dark .reportEnrolsWeeduc :deep(.weeduc-admin-reports-filters--stacked.weeduc-admin-page__toolbar) {
    border-bottom-color: transparent;
}
</style>
